import type { ShippingFeesPromo } from '../../lib/api/operatorConsole';
import { formatAmount } from './formatMoney';

interface Props {
  promo: ShippingFeesPromo;
  currency: string | null;
}

/** The fee lines above are what the player paid; these two say what that
 *  price replaced and what the operator covered. */
export function ShippingPromoLines({ promo, currency }: Props) {
  return (
    <dl className="mt-3 space-y-1 border-t border-ui-border pt-3 text-sm">
      <div className="flex justify-between gap-4">
        <dt className="text-ui-text-secondary">Regular shipping + handling</dt>
        <dd className="font-mono text-ui-text">
          {formatAmount(promo.original_shipping + promo.original_handling, currency)}
        </dd>
      </div>
      <div className="flex justify-between gap-4">
        <dt className="text-ui-text-secondary">
          Promotion discount
          <span className="block text-xs">{promo.label}</span>
        </dt>
        <dd className="font-mono text-ui-text">-{formatAmount(promo.discount, currency)}</dd>
      </div>
    </dl>
  );
}
